import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import associateReducer from "@/features/associate";
import authReducer from "@/features/auth";
import bankReducer from "@/features/bank";
import businessReducer from "@/features/business";
import bulletFactoryReducer from "@/features/bullet-factory";
import crateReducer from "@/features/crate-opening";
import crimeReducer from "@/features/crime";
import daoReducer from "@/features/marketing-dao";
import carCrusherReducer from "@/features/car-crusher";
import safehouseReducer from "@/features/safehouse";
import smugglingReducer from "@/features/smuggling";
import detectiveReducer from "@/features/detective-agency";
import equipmentReducer from "@/features/equipment";
import exchangeReducer from "@/features/exchange";
import familyReducer from "../features/family/model/family.slice";
import garageReducer from "@/features/garage";
import inboxReducer from "@/features/inbox";
import hospitalReducer from "@/features/hospital";
import inventoryReducer from "@/features/inventory";
import gameIntelligenceReducer from "@/features/game-intelligence";
import helperBotReducer from "@/features/helper-bot";
import jackpotReducer from "@/features/jackpot";
import killSkillReducer from "@/features/kill-skill";
import lotteryHallReducer from "@/features/lottery-hall";
import nickCarReducer from "@/features/nick-car";
import jailReducer from "@/features/jail";
import mapReducer from "@/features/map";
import marketReducer from "../features/market/model/market.slice";
import metricsReducer from "@/features/metrics";
import mysteryBoxReducer from "@/features/mystery-box";
import notificationReducer from "@/features/notifications";
import organizedCrimeReducer from "../features/organized-crime/model/organizedCrime.slice";
import perkReducer from "@/features/perks";
import playerReducer from "@/features/player-directory";
import playerWorthReducer from "@/features/player-worth";
import premiumReducer from "@/features/premium";
import profileReducer from "@/features/profile";
import rankActivationReducer from "@/features/rank-activation";
import referralReducer from "@/features/referral";
import rouletteReducer from "@/features/roulette";
import shopReducer from "@/features/shop";
import slotReducer from "@/features/slot";
import trainingReducer from "@/features/bodyguard";
import vaultReducer from "@/features/vault";
import tokenPricesReducer from "@/features/token-prices";
import xpMarketReducer from "@/features/xp-market";
import raceReducer from "@/features/race";
import storyReducer, { weeklyMissionsReducer } from "@/features/story";
import travelReducer from "@/features/travel";
import bulletHistoryReducer from "@/features/bullet-history";
import cashHistoryReducer from "@/features/cash-history";
import creditHistoryReducer from "@/features/credit-history";
import giCreditHistoryReducer from "@/features/gi-credit-history";
import healthHistoryReducer from "@/features/health-history";
import attemptedKillsReducer from "@/features/attempted-kills";
import backfireReducer from "@/features/backfire-settings";
import killHistoryReducer from "@/features/kill-history";
import killOutcomeReducer from "@/features/kill-outcome-battle";
import rebirthReducer from "@/features/rebirth";

export const store = configureStore({
  reducer: {
    profile: profileReducer,
    associate: associateReducer,
    family: familyReducer,
    player: playerReducer,
    playerWorth: playerWorthReducer,
    notification: notificationReducer,
    organizedCrime: organizedCrimeReducer,
    crate: crateReducer,
    crime: crimeReducer,
    market: marketReducer,
    vault: vaultReducer,
    tokenPrices: tokenPricesReducer,
    xpMarket: xpMarketReducer,
    race: raceReducer,
    story: storyReducer,
    weeklyMissions: weeklyMissionsReducer,
    auth: authReducer,
    bank: bankReducer,
    exchange: exchangeReducer,
    map: mapReducer,
    dao: daoReducer,
    roulette: rouletteReducer,
    business: businessReducer,
    bulletFactory: bulletFactoryReducer,
    slot: slotReducer,
    garage: garageReducer,
    jail: jailReducer,
    perk: perkReducer,
    jackpot: jackpotReducer,
    killSkill: killSkillReducer,
    lotteryHall: lotteryHallReducer,
    nickCar: nickCarReducer,
    shop: shopReducer,
    inbox: inboxReducer,
    hospital: hospitalReducer,
    inventory: inventoryReducer,
    gameIntelligence: gameIntelligenceReducer,
    helperBot: helperBotReducer,
    training: trainingReducer,
    equipment: equipmentReducer,
    metrics: metricsReducer,
    mysteryBox: mysteryBoxReducer,
    premium: premiumReducer,
    rankActivation: rankActivationReducer,
    referral: referralReducer,
    carCrusher: carCrusherReducer,
    safehouse: safehouseReducer,
    detective: detectiveReducer,
    rebirth: rebirthReducer,
    backfire: backfireReducer,
    killHistory: killHistoryReducer,
    attemptedKills: attemptedKillsReducer,
    killOutcome: killOutcomeReducer,
    smuggling: smugglingReducer,
    travel: travelReducer,
    bulletHistory: bulletHistoryReducer,
    cashHistory: cashHistoryReducer,
    creditHistory: creditHistoryReducer,
    giCreditHistory: giCreditHistoryReducer,
    healthHistory: healthHistoryReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
